export default "__VITE_ASSET__977cb1a5__"